import { useState } from "react"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"
import openIcon from "./selecticon.png"
import { Button } from "components"

export const BusFileItem = ({ index, item }: any) => {
 // language translator
 const { t } = useTranslation("translation")
 const [openCards, setOpenCards] = useState<number[]>([])
 const [rotate, setRotate] = useState<boolean>(false)
 const toggleCard = (index: any) => {
  if (openCards.includes(index)) {
   setOpenCards(openCards.filter((cardIndex) => cardIndex !== index))
  } else {
   setOpenCards([...openCards, index])
  }
  setRotate(!rotate)
 }

 return (
  <div key={index} className="w-full">
   <Box bg="highlight" className=" w-full py-3 rounded">
    <Box
     bg="gray"
     color="text-black"
     style={{ margin: "0 auto" }}
     className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3"
    >
     <h1>{item.heading}</h1>
     <div
      onClick={() => toggleCard(index)}
      className="h-6 w-6 rounded bg-golden flex items-center justify-center cursor-pointer"
     >
      <img className={`${rotate ? "rotate-360" : "rotate-180"}`} src={openIcon} alt="icon" />
     </div>
    </Box>
    <div>
     {openCards.includes(index) && (
      <div>
       {item.submenu.map((sub: any, index: number) => (
        <Box key={index} bg="highlight" color="text-black">
         <div
          className={`border-b-[1.5px] border-light-gray pb-3 w-full animate-move-card ${
           index === item?.submenu?.length - 1 ? "border-none pb-0" : ""
          }`}
         >
          {sub.info !== "" ? (
           <div className="flex w-full justify-between px-4 ">
            <h1 className="w-[50%]">{sub.heading}</h1>
            <h1 className="w-[50%]">{sub.info}</h1>
           </div>
          ) : (
           ""
          )}
         </div>
        </Box>
       ))}
      </div>
     )}
    </div>
    <div className="w-[96%] mx-auto pt-4">
     <Button size={"lg"}>{t("create")}</Button>
    </div>
   </Box>
  </div>
 )
}
